import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { StartPageSite } from "../StartPage.types";

function useStartPageSites(projectId?: string) {
  const { data, error, isLoading } = useQuery({
    queryKey: urls.startPage.sites.key(projectId),
    queryFn: () => fetchStartPageSites(projectId)
  });

  return {
    sites: data,
    isLoading,
    error
  };
}

async function fetchStartPageSites(projectId?: string) {
  const response = await apiWithoutCamelization.get<Array<StartPageSite>>(
    urls.startPage.sites.url(projectId)
  );
  return response.data;
}

export { useStartPageSites };
